<template>
  <el-form
    class="form-container"
    ref="form"
    label-position="top"
    :model="formModel"
    :rules="configRules"
  >
    <el-form-item :label="`${rentPeriodDesc.label}`">
      <el-input v-model="rentPeriodDesc.value" disabled></el-input>
    </el-form-item>
    <el-form-item
      v-if="configData.showFormItem.includes('payMode')"
      prop="payMode"
      label="收款方式"
    >
      <template v-if="((transformDisabled || payModeDisabled) && tempFormData.payMode) || payModeToText">
        {{ formData.payMode | enumerationFilter(paymentMethods) }}
      </template>
      <el-radio-group
        v-else
        v-model="formData.payMode"
        @change="payModeChange"
      >
        <el-radio
          v-for="item in paymentMethods"
          :label="item.value"
          :key="item.value"
          :disabled="item.disabled"
          >{{ item.label }}</el-radio
        >
      </el-radio-group>
    </el-form-item>
    <!-- 提车时需缴纳，不包含后置费项 -->
    <el-form-item
      prop="advancePayment"
      label="提车时需缴纳"
    >
      <template slot="label">
        <label>提车时需缴纳</label>
        <el-tooltip effect="dark" placement="top">
          <i class="QS-icon-question-outline"></i>
          <template #content>
            <span>选择缴纳费用时，司机在商城下单时需在线支付对应的金额</span>
          </template>
        </el-tooltip>
      </template>
      <el-radio-group
        v-model="formData.advancePayment"
        :disabled="transformDisabled || isECommerce"
      >
        <el-radio
          v-for="item in advancePaymentList"
          :label="item.value"
          :key="item.value"
          >{{ item.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- 仅当收款方式选择为“月付（自然月）”或“月付（满月）”或“周付”时，需展示并填写该字段。 -->
    <el-form-item
      v-if="
        configData.showFormItem.includes('amountAccuracy') &&
        [
          PAYMODE_CODE_MAP.WEEK,
          PAYMODE_CODE_MAP.FULL_MOON,
          PAYMODE_CODE_MAP.NATURAL_MONTH,
        ].includes(formData.payMode)
      "
      prop="amountAccuracy"
      label="收款金额保留位数"
    >
      <el-radio-group
        v-model="formData.amountAccuracy"
        :disabled="(transformDisabled && tempFormData.amountAccuracy) || isECommerce"
        @change="amountAccuracyChange"
        >
        <el-radio :label="0">金额取整</el-radio>
        <el-radio :label="2">金额保留两位小数</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- 租金类型 -->
    <el-form-item
      prop="payPlanType"
      label="租金类型"
      v-if="configData.fundType === FEE_CODE_MAP.ZU_JIN"
      >
      <el-radio-group
        :disabled="transformDisabled || payModeDisabled  || isECommerce"
        :value="formData.payPlanType"
        @change="rentTypeChange"
        >
        <el-radio :label="RENT_TYPE.FIXEDRENT"> 固定租金</el-radio>
        <el-radio
          :label="RENT_TYPE.DYNAMICRENT">动态租金</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- 收款金额 -->
    <el-form-item
      v-if="
        configData.showFormItem.includes('amount') &&
        formData.payPlanType !== RENT_TYPE.DYNAMICRENT
      "
      v-show="
        !(
          formData.fundType === FEE_CODE_MAP.YA_JIN &&
          formData.payMode === 11
        )
      "
      prop="amount"
      label="收款金额"
      :required="amountRequired"
      :inline-message="true"
      :rules="[{ required: amountRequired, trigger: 'blur', validator: amountValidate }]"
    >
      <div v-if="payAmountStages">
        <div class="amountType_box">
          <el-form-item :error="rentError">
            <div
              v-if="
                formData.amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
              "
              class="amountType_box_item"
              >
              <span>每期</span>
              <el-input
                v-if="formData.amountAccuracy === 0"
                v-model="formData.rentPerPeriod"
                :disabled="transformDisabled || isECommerce"
                v-integerNumber="{
                  min: 0,
                  max: 999999999,
                }"
                placeholder="请输入"
                class="input"
                @blur="handleIntegerRentPlanChange"
              />
              <el-input
                v-if="formData.amountAccuracy === 2"
                v-model="formData.rentPerPeriod"
                :disabled="transformDisabled || isECommerce"
                v-number:money="{
                  isHideErr: true,
                }"
                placeholder="请输入"
                class="input"
                @blur="rentPlanChange"
              />
              <span>元</span>
            </div>
            <div v-else class="amountType_box_item">
              <span>每日</span>
              <el-input
                v-if="formData.amountAccuracy === 0"
                v-model="formData.rentDay"
                :disabled="transformDisabled || isECommerce"
                v-integerNumber="{
                  min: 0,
                  max: 999999999,
                }"
                placeholder="请输入"
                class="input cycleRent"
                @blur="handleIntegerRentPlanChange"
              />
              <el-input
                v-if="formData.amountAccuracy === 2"
                v-model="formData.rentDay"
                :disabled="transformDisabled || isECommerce"
                v-number:money="{
                  isHideErr: true,
                }"
                placeholder="请输入"
                class="input cycleRent"
                @blur="rentPlanChange"
              /><span>元 x 每期自然天数</span>
            </div>
            <div v-if="!(transformDisabled || payModeDisabled || isECommerce)">
              <el-button type="text" @click="toggleAlgorithm">{{
                amountText[formData.amountType]
              }}</el-button>
            </div>
          </el-form-item>
        </div>
      </div>
      <div v-else class="amount">
        <el-form-item :error="rentError">
          <span class="amountDesc amountDesc1" v-if="amountDesc && formData.payMode === PAYMODE_CODE_MAP.DAY" >{{ amountDesc }}</span>
          <span class="amountDesc amountDesc2" v-if="amountDesc && formData.payMode !== PAYMODE_CODE_MAP.DAY" >{{ amountDesc }}</span>
          <!-- 押金且为分期 -->
          <el-input
            class="amountDesc"
            v-model="formData.amount"
            v-if="
              formData.fundType === FEE_CODE_MAP.YA_JIN &&
              formData.payMode === 11
            "
            v-show="isAddScheme"
            v-integerNumber="{
              min: 0,
              max: 999999999,
            }"
            :disabled="transformDisabled || isECommerce"
            placeholder="请输入"
            @blur="amountChange"
            >
            <template slot="append">元</template>
          </el-input>
          <el-input
            class="amountDesc"
            v-model="formData.amount"
            v-else-if="
              formData.fundType === FEE_CODE_MAP.YA_JIN &&
              formData.payMode === 6
            "
            v-integerNumber="{
              min: 0,
              max: 999999999,
            }"
            :disabled="transformDisabled || isECommerce"
            placeholder="请输入"
            >
            <template slot="append">元</template>
          </el-input>
          <!-- 其他且取整数 -->
          <el-input
            v-else-if="
              formData.fundType === FEE_CODE_MAP.OTHERS &&
              formData.amountAccuracy === 0
            "
            class="amountDesc"
            v-model="formData.amount"
            v-integerNumber="{
              min: 0,
              max: 999999999,
            }"
            :disabled="transformDisabled || isECommerce"
            placeholder="请输入"
            >
            <template slot="append">元</template>
          </el-input>
          <!-- 其他且保留两位小数 -->
          <el-input
            v-else-if="
              formData.fundType === FEE_CODE_MAP.OTHERS &&
              formData.amountAccuracy === 2
            "
            class="amountDesc"
            v-model="formData.amount"
            v-number:money="{
              isHideErr: true,
            }"
            :disabled="transformDisabled || isECommerce"
            placeholder="请输入"
            >
            <template slot="append">元</template>
          </el-input>
          <!-- 剩余其他类型 -->
          <el-input
            v-else
            class="amountDesc"
            v-model="formData.amount"
            v-number:money="{
              isHideErr: true,
            }"
            :disabled="transformDisabled || isECommerce"
            placeholder="请输入"
            @blur="amountChange"
            >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </div>
    </el-form-item>

    <!-- 押金阶梯 -->
    <el-form-item
      v-if="
        configData.showFormItem.includes('amount') &&
        formData.fundType === FEE_CODE_MAP.YA_JIN &&
        formData.payMode === 11 &&
        isAddScheme
      "
      label="收款期数"
      prop="depositInstallmentListCopy"
      class="periods"
      required
    >
      <el-alert title="共" type="info" :closable="false">
        <template slot="title">
          共
          <span class="a-hover-link">{{
            depositInstallmentListCopy.length
          }}</span>
          期，收款总金额
          <span class="a-hover-link">{{ format(alertTitle) }} 元</span> 。
        </template>
      </el-alert>
      <el-table :data="depositInstallmentListCopy" :max-height="null" style="max-height: null !important;">
        <el-table-column prop="numberOfPeriods" label="期数" width="120">
          <template slot-scope="scope">
            第{{ scope.row.numberOfPeriods }}期
          </template>
        </el-table-column>
        <el-table-column prop="presentAmount" label="收款金额">
          <template slot-scope="scope">
            <el-form-item
              :prop="`depositInstallmentListCopy[${scope.$index}].presentAmount`"
              :rules="[
                { required: true, message: '请输入金额', trigger: 'blur' },
                { validator: validatePeriodAmount, trigger: 'blur' },
              ]"
              :class="{ 'no-error-margin': true }"
            >
              <el-input
                v-model="depositInstallmentListCopy[scope.$index].presentAmount"
                placeholder="请输入金额"
                :disabled="transformDisabled || isECommerce"
                v-integerNumber="{
                  min: 0,
                  max: 999999999,
                }"
                @input="handlePeriodAmountChange"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 新增删除列 -->
        <el-table-column
          label="操作"
          width="61"
          align="center"
          v-if="!transformDisabled"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDeletePeriod(scope.$index)"
              :disabled="depositInstallmentListCopy.length <= 1 || isECommerce"
              >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="add-periods">
        <el-button
          type="text"
          icon="el-icon-plus"
          @click="addPeriod"
          :disabled="addPeriodDisabled || isECommerce"
          >添加期数</el-button
        >
      </div>
    </el-form-item>
    <!-- 新滞纳金表单项-start -->
    <el-form-item
      v-if="configData.showFormItem.includes('lateFeeProportion')"
      prop="lateFeeProportion"
      label="收取比例"
      >
      <div class="input-container">
        每日未付租金*
        <el-input
          :disabled="transformDisabled || isECommerce"
          placeholder="请输入"
          v-number:float
          class="input proportion"
          v-model="formData.lateFeeProportion"
        />
        %
      </div>
    </el-form-item>
    <el-form-item
      v-if="configData.showFormItem.includes('interestFreeDays')"
      prop="interestFreeDays"
      label="免息天数"
      >
      <div class="input-container">
        <el-input
          class="input"
          :disabled="transformDisabled || isECommerce"
          placeholder="限制0-365之间数字"
          v-model.number="formData.interestFreeDays"
          v-integerNumber="{
            min: 0,
            max: 365,
          }"
        >
          <template slot="append">日</template>
      </el-input>
      </div>
    </el-form-item>
    <!-- 新滞纳金表单项-end -->
    <!-- 动态租金条件-start -->
    <div v-if="formData.payPlanType === RENT_TYPE.DYNAMICRENT">
      <el-form-item prop="dynamicType" label="动态条件">
        <el-input
          :value="DYNAMIC_TYPE_TEXT[formData.dynamicType]"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item prop="spId" label="完单平台">
        <el-select
          v-model="formData.spId"
          clearable
          :disabled="transformDisabled || payModeDisabled || isECommerce"
          placeholder="请选择"
          @change="spIdChange"
        >
          <el-option
            v-for="item in spIdList"
            :key="item.spId"
            :label="item.spName"
            :value="item.spId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="dynamicList" label="租金规则" :error="RentRulesError">
        <div class="rentRules">
          <div
            v-for="(item, index) in formData.dynamicList"
            :key="index"
            style="margin-bottom: 10px"
            class="dynamicItem"
          >
            {{ item.startValue }} ≤
            {{ DYNAMIC_TYPE_TEXT[formData.dynamicType] }} <
            <span v-if="item.endValue === null">不限</span>
            <el-form-item
              v-else
              :prop="`dynamicList[${index}].endValue`"
              :rules="endValueValidator(index)"
            >
              <el-input
                v-model="item.endValue"
                :disabled="
                  item.maxDisabled || transformDisabled || payModeDisabled || isECommerce
                "
                v-integerNumber="{
                  min: 0,
                  max: 10000,
                }"
                placeholder="请输入"
                class="rentRules-orderNum"
              />
            </el-form-item>
            , 每期租金
            <el-form-item
              :prop="`dynamicList[${index}].amount`"
              :rules="amountValidator(index)"
            >
              <el-input
                :disabled="transformDisabled || payModeDisabled || isECommerce"
                v-model="item.amount"
                v-number:money="{
                  isHideErr: true,
                }"
                placeholder="请输入"
                class="rentRules-money"
              />
            </el-form-item>
            <el-button
              type="text"
              class="delRentRules"
              v-if="
                !(transformDisabled || payModeDisabled || isECommerce) &&
                index !== 0 &&
                index !== formData.dynamicList.length - 1
              "
              @click="delRentRules(index)"
              >删除</el-button
            >
          </div>
          <el-button
            type="text"
            @click="addRentRules"
            v-if="!(transformDisabled || payModeDisabled || isECommerce)"
            >添加规则</el-button
          >
        </div>
      </el-form-item>
    </div>
    <!-- 动态租金条件-end -->
  </el-form>
</template>
<script>
import {
  checkDynamicRent,
  dynamicRentSpCheck,
  dynamicRentSpList,
} from '@/api/carManage'
import {
  AMOUNTTYPE_CODE_MAP,
  CATEGORY_CODE_MAP,
  FEE_CODE_MAP,
  PAYMODE_CODE_MAP,
} from '@/store/dict/rentPlanDict'
import { numberUtils } from '@/utils/number'
import { cloneDeep } from 'lodash'
import {
  configRules,
  DYNAMIC_TYPE,
  DYNAMIC_TYPE_TEXT,
  paymentMethodsList,
  RENT_TYPE,
  ADVANCE_PAYMENT_CODE,
  ADVANCE_PAYMENT_LIST,
} from '../config.js'
import { dict2list } from '@/utils'

const { plus, lte, format } = numberUtils

export default {
  props: {
    tempFormData: {
      type: Object,
      default: () => ({}),
    },
    configData: {
      type: Object,
      default: () => ({}),
    },
    configDisabled: {
      type: Boolean,
      default: false,
    },
    // 是否是新增方案
    isAddScheme: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/no-unused-properties
    rentCategory: {
      type: Number,
      default: 1,
    },
    // 是否为商城单，商城单不允许修改
    // eslint-disable-next-line vue/no-unused-properties
    isECommerce: {
      type: Boolean,
      default: false,
    },
    // 是否为续约单，true为是，false为否
    isRenew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // eslint-disable-next-line vue/no-unused-properties
      CATEGORY_CODE_MAP,
      DYNAMIC_TYPE_TEXT,
      FEE_CODE_MAP,
      AMOUNTTYPE_CODE_MAP,
      RENT_TYPE,
      PAYMODE_CODE_MAP,
      configRules: {
        ...configRules,
      },
      rentError: '',
      RentRulesError: '',
      depositInstallmentListCopy: [{ numberOfPeriods: 1, presentAmount: '' }],
      formData: {
        amount: '',
        payPlanType: RENT_TYPE.FIXEDRENT,
        dynamicType: DYNAMIC_TYPE.OVER_ORDER_NUM,
        dynamicList: [],
        amountType: AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD,
        advancePayment: '',
      },
      amountText: {
        [AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD]: '点击可切换为日租金算法',
        [AMOUNTTYPE_CODE_MAP.DAILY_RENT]: '点击可切换为每期算法',
      },
      spIdList: [],
    }
  },
  filters: {
    // 收款项显示中文
    enumerationFilter(val, list) {
      const label = (list && list.find((item) => {
        return Number(item.value) === Number(val)
      })?.label) || '--'
      return label
    },
  },
  computed: {
    amountRequired() {
      return !(this.formData?.fundType === FEE_CODE_MAP.YA_JIN &&
      this.formData?.payMode === 11)
    },
    alertTitle() {
      // 检查是否所有的 presentAmount 都为空字符串
      const allEmpty = this.depositInstallmentListCopy.every(
        (item) => item.presentAmount === '',
      )
      if (allEmpty) {
        return ''
      }

      const money = this.depositInstallmentListCopy.reduce(
        (total, item) => plus(total, Number(item.presentAmount || 0)),
        0,
      )
      return money
    },
    formModel() {
      return {
        ...this.formData,
        depositInstallmentListCopy: this.depositInstallmentListCopy,
      }
    },
    addPeriodDisabled() {
      // 检查depositInstallmentList是否存在
      if (!this.depositInstallmentListCopy) {
        return false
      }
      return this.depositInstallmentListCopy.length >= 12
    },
    // 收款方式与外面一致，显示纯文本
    payModeToText() {
      const { fundType } = this.configData
      if (this.isECommerce) {
        return true
      }
      return [
        FEE_CODE_MAP.ZU_JIN,
        FEE_CODE_MAP.GUAN_LI_FEE,
        FEE_CODE_MAP.FU_WU_FEE,
        FEE_CODE_MAP.SHOU_FU_KUAN,
        FEE_CODE_MAP.WEI_KUAN,
        FEE_CODE_MAP.QUAN_KUAN,
      ].includes(fundType)
    },
    // 收款方式置灰,即纯文本展示
    payModeDisabled() {
      const { fundType } = this.configData
      return [
        FEE_CODE_MAP.SHOU_FU_KUAN,
        FEE_CODE_MAP.QUAN_KUAN,
        FEE_CODE_MAP.DING_JIN,
        FEE_CODE_MAP.BAO_ZHENG_JIN,
        FEE_CODE_MAP.ZHI_NA_JIN,
        FEE_CODE_MAP.WEI_KUAN,
      ].includes(fundType)
    },
    // 收款方式列表
    paymentMethods() {
      const { fundType } = this.configData
      const list =
        paymentMethodsList.find((item) => item.code === fundType)?.list || []
      if (FEE_CODE_MAP.ZU_JIN === fundType) {
        // 6 一次性
        return list.filter((item) => item.value !== 6)
      }
      return list
    },
    // 收款金额描述
    amountDesc() {
      if (this.formData.payMode === PAYMODE_CODE_MAP.DAY) {
        return '日租金'
      }
      if (
        this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE ||
        this.formData.fundType === FEE_CODE_MAP.YA_JIN
      ) {
        return ''
      }
      return '每期总金额'
    },
    // 租赁时间展示文案
    rentPeriodDesc() {
      const label = this.isAddScheme ? '租期' : '收款起止日期'
      if (this.isAddScheme) {
        let unit = ''
        const { rentPeriodType, rentPeriod } = this.formData
        if (rentPeriodType === 1) {
          unit = '天'
        } else if (rentPeriodType === 3) {
          unit = '个月'
        }
        return {
          label,
          value: `${rentPeriod}${unit}`,
        }
      }
      return {
        label,
        value: `${
          (this.formData.startTime && this.formData.startTime.split(' ')[0]) ||
          ''
        } 至 ${
          (this.formData.endTime && this.formData.endTime.split(' ')[0]) || ''
        }`,
      }
    },
    // 是否分期展示收款金额
    payAmountStages() {
      return (
        this.configData.fundType === FEE_CODE_MAP.ZU_JIN &&
        [
          PAYMODE_CODE_MAP.WEEK,
          PAYMODE_CODE_MAP.FULL_MOON,
          PAYMODE_CODE_MAP.NATURAL_MONTH,
          '',
        ].includes(this.formData.payMode)
      )
    },
    // 是否禁用
    transformDisabled() {
      // 兼容续约时平移押金禁止修改押金配置
      return (
        this.configDisabled ||
        (this.configData.formData.isTranDeposit &&
          this.configData.fundType === FEE_CODE_MAP.YA_JIN)
      )
    },
    // 提车时需缴纳枚举值
    advancePaymentList() {
      const list = dict2list(ADVANCE_PAYMENT_LIST)
      if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        return list.filter((item) => item.value !== ADVANCE_PAYMENT_CODE.FIRST_PERIOD)
      }
      return list.filter((item) => item.value !== ADVANCE_PAYMENT_CODE.ALL)
    },
  },
  methods: {
    format,
    amountChange() {
      this.rentError = ''
      if (
        this.formData.payMode === PAYMODE_CODE_MAP.DAY
          && this.formData.amount > 300 && this.rentCategory === this.CATEGORY_CODE_MAP.ZU_CHE) {
        this.rentError = '日付租金上限为 300 元，超出限制请重新设置！'
      }
    },
    // 处理整数金额输入
    handleIntegerRentPlanChange(e) {
      // 如果有小数点，去掉小数部分
      if (e.target.value && e.target.value.includes('.')) {
        this.formData.rentPerPeriod = parseInt(e.target.value, 10).toString()
      }
      // 移除前导零，但保留单个0
      if (
        this.formData.rentPerPeriod &&
        this.formData.rentPerPeriod.startsWith('0') &&
        this.formData.rentPerPeriod.length > 1
      ) {
        this.formData.rentPerPeriod = parseInt(
          this.formData.rentPerPeriod,
          10,
        ).toString()
      }
      // 调用原来的方法
      this.rentPlanChange(e)
    },
    handleDeletePeriod(index) {
      this.depositInstallmentListCopy.splice(index, 1)
      // 删除后重新设置期数编号
      this.updatePeriodNumbers()
      // 重新验证
      this.handlePeriodAmountChange()
      // 先清除验证错误
      this.$nextTick(() => {
        // 清除所有期数的验证错误
        this.depositInstallmentListCopy.forEach((_, i) => {
          this.$refs.form.clearValidate(`depositInstallmentListCopy[${i}].presentAmount`)
        })
      })
    },
    // 更新期数编号
    updatePeriodNumbers() {
      this.depositInstallmentListCopy.forEach((item, index) => {
        item.numberOfPeriods = index + 1
      })
    },
    // 验证每期金额
    validatePeriodAmount(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入金额'))
        return
      }
      const amount = Number(value)
      if (lte(amount, 0)) {
        callback(new Error('金额必须大于0'))
        return
      }
      callback()
    },
    // 处理每期金额变化
    handlePeriodAmountChange() {
      this.$nextTick(() => {
        // 验证所有期数的金额
        this.depositInstallmentListCopy.forEach((_, index) => {
          this.$refs.form.validateField(
            `depositInstallmentListCopy[${index}].presentAmount`,
          )
        })
      })
    },
    // 新增期数
    addPeriod() {
      // 检查是否是押金且分期付款
      if (
        this.formData.fundType !== FEE_CODE_MAP.YA_JIN ||
        this.formData.payMode !== 11
      ) {
        return
      }

      if (this.depositInstallmentListCopy.length >= 12) {
        this.$message.warning('最多支持添加12期')
        return
      }

      // 确保depositInstallmentList已初始化
      if (!this.depositInstallmentListCopy) {
        this.depositInstallmentListCopy = []
      }

      // 先清除验证错误
      this.$nextTick(() => {
        // 清除所有期数的验证错误
        this.depositInstallmentListCopy.forEach((_, index) => {
          this.$refs.form.clearValidate(`depositInstallmentListCopy[${index}].presentAmount`)
        })
      })

      // 添加新期数
      const newPeriodNumber = this.depositInstallmentListCopy.length + 1
      this.depositInstallmentListCopy.push({
        numberOfPeriods: newPeriodNumber,
        presentAmount: '',
      })

      // 添加滚动到新行的逻辑
      this.$nextTick(() => {
        // 清除验证错误
        this.depositInstallmentListCopy.forEach((_, index) => {
          this.$refs.form.clearValidate(`depositInstallmentListCopy[${index}].presentAmount`)
        })
        // 获取表格的 body wrapper
        const tableBody = this.$el.querySelector('.el-table__body-wrapper')
        if (tableBody) {
          // 滚动到底部
          tableBody.scrollTop = tableBody.scrollHeight
        }
      })
    },
    // 每一阶梯的上限校验
    endValueValidator(index) {
      return [
        {
          validator: (_, value, callback) => {
            if (!value) {
              callback(new Error('每一阶梯上限必须填写'))
              return
            }
            const targetRentInfo = this.formData.dynamicList[index]
            if (Number(targetRentInfo.startValue) === Number(value)) {
              this.$set(this.formData.dynamicList[index], 'endValue', '')
              callback(new Error('阶梯的上限下限不能一致'))
              return
            }

            if (Number(value) < Number(targetRentInfo.startValue)) {
              this.$set(this.formData.dynamicList[index], 'endValue', '')
              callback(new Error('阶梯的上限不能小于下限'))
              return
            }

            if (index === this.formData.dynamicList.length - 2) {
              const len = this.formData.dynamicList.length
              this.$set(
                this.formData.dynamicList[len - 1],
                'startValue',
                this.formData.dynamicList[len - 2].endValue,
              )
            }
            callback()
          },
          trigger: ['blur'],
        },
      ]
    },
    amountValidator(index) {
      return [
        {
          validator: (_, value, callback) => {
            if (!value) {
              callback(new Error('收款金额不能为空'))
              return
            }
            if (!this.isRenew && Number(value) === 0) {
              callback(new Error('租金不能为0'))
              return
            }
            if (this.formData.dynamicList.some((item, idx) => Number(item.amount) === Number(value) && idx !== index && item.amount !== '')) {
              callback(new Error('租金金额重复'))
              this.formData.dynamicList[index].amount = ''
              return
            }
            callback()
          },
          trigger: ['blur'],
        },
      ]
    },

    async spIdChange(spId) {
      if (!spId) return
      // 校验对应网约平台是否完成网约运营数据共享
      const [err] = await this.$to(dynamicRentSpCheck({ spId }))
      if (err && err.code === 29029) {
        this.formData.spId = ''
        this.checkDataSharing(err.msg)
      }
    },
    // 切换租金类型
    async rentTypeChange(v) {
      if (v === 0) {
        // 判断是否配置网约运营数据共享
        const [err] = await this.$to(checkDynamicRent())
        if (err && err.code === 29028) {
          this.checkDataSharing(err.msg)
          return
        }
      }
      this.$refs.form.clearValidate()
      this.formData.payPlanType =
        v === RENT_TYPE.FIXEDRENT ? RENT_TYPE.DYNAMICRENT : RENT_TYPE.FIXEDRENT
      this.formData.rentPerPeriod = ''
      this.formData.rentDay = ''
      this.formData.dynamicList = [
        {
          startValue: 0, // 最小完单量
          endValue: '', // 最大完单量
          amount: '', // 租金
          maxDisabled: false,
        },
        {
          startValue: '', // 最小完单量
          endValue: null, // 最大完单量
          amount: '', // 租金
          maxDisabled: false,
        },
      ]
      // 选择动态租金后拉取完单平台列表
      if (this.formData.payPlanType === RENT_TYPE.DYNAMICRENT) {
        this.getDynamicRentSpList()
        // 切换到动态租金时，金额类型修改为每期租金
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
        console.error('this.formData.amountType', this.formData.amountType)
      }
    },
    // 获取完单平台
    async getDynamicRentSpList() {
      const { code, data } = await dynamicRentSpList()
      if (code === 1) {
        this.spIdList = data || []
      }
    },
    // 租金规则
    async addRentRules() {
      const rulesLen = this.formData.dynamicList.length

      if (rulesLen >= 5) {
        this.$message.error('最多只能添加 5 个阶梯')
        return
      }

      const preRule = this.formData.dynamicList[rulesLen - 2]
      const { endValue, amount } = preRule

      // 先校验上一条数据是否有效
      try {
        // 校验上一条规则的字段
        await this.$refs.form.validateField(
          `dynamicList[${rulesLen - 2}].endValue`,
        )
        await this.$refs.form.validateField(
          `dynamicList[${rulesLen - 2}].amount`,
        )
      } catch (error) {
        // 如果校验不通过，直接返回，不添加新规则
        return
      }

      if (!endValue || !amount) {
        this.$message.error('请输入完单量或每期租金')
        return
      }

      if (endValue >= 10000) {
        this.$message.error('完单量已达上限,请修改后重新配置')
        return
      }

      preRule.maxDisabled = true

      // 添加新规则
      this.formData.dynamicList.splice(rulesLen - 1, 0, {
        startValue: endValue,
        endValue: '',
        amount: '',
        maxDisabled: false,
      })

      this.formData.dynamicList[
        this.formData.dynamicList.length - 1
      ].startValue = ''

      // 清除新添加行的校验状态
      this.$nextTick(() => {
        // 清除新添加行的校验状态
        this.$refs.form.clearValidate([
          `dynamicList[${rulesLen - 1}].endValue`,
          `dynamicList[${rulesLen - 1}].amount`,
        ])
      })
    },
    delRentRules(index) {
      this.formData.dynamicList.splice(index, 1)
      const len = this.formData.dynamicList.length

      if (len === 2) {
        this.formData.dynamicList[0].maxDisabled = false
        this.formData.dynamicList[1].endValue = null
        this.formData.dynamicList[1].startValue =
          this.formData.dynamicList[0].endValue
      } else {
        for (let i = 1; i < len; i++) {
          this.formData.dynamicList[i].startValue =
            this.formData.dynamicList[i - 1].endValue
        }
        this.formData.dynamicList[len - 1].maxDisabled = false
      }

      // 删除后重新设置校验状态
      this.$nextTick(() => {
        // 清除所有动态规则的校验状态
        for (let i = 0; i < this.formData.dynamicList.length; i++) {
          this.$refs.form.clearValidate([
            `dynamicList[${i}].endValue`,
            `dynamicList[${i}].amount`,
          ])
        }

        // 如果需要，重新触发校验
        if (this.formData.dynamicList.length > 0) {
          this.$refs.form.validateField([
            `dynamicList[${this.formData.dynamicList.length - 1}].endValue`,
            `dynamicList[${this.formData.dynamicList.length - 1}].amount`,
          ])
        }
      })
    },

    // 校验对应网约平台是否完成网约运营数据共享
    checkDataSharing(text) {
      this.instanceMessage && this.instanceMessage.close()
      const h = this.$createElement
      this.instanceMessage = this.$message({
        showClose: true,
        message: h('div', { style: 'padding-right:24px' }, [
          h('span', null, text),
          h(
            'el-button',
            {
              props: { type: 'text' },
              style: { paddingLeft: '8px' },
              on: {
                click: () => {
                  // 关闭message
                  this.instanceMessage.close()
                  // 关闭遮罩
                  this.$emit('closeDrawer')
                  // 处理按钮点击事件
                  this.$router.push({
                    path: '/tenant/linkage/secret/list',
                  })
                },
              },
            },
            '立即配置',
          ),
        ]),
        duration: 5000,
        type: 'warning',
      })
    },
    toggleAlgorithm() {
      this.formData.amountType =
        this.formData.amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
          ? AMOUNTTYPE_CODE_MAP.DAILY_RENT
          : AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
      this.formData.rentPerPeriod = ''
      this.formData.rentDay = ''
      this.rentError = ''
    },
    rentPlanChange(e) {
      const { value } = e.target
      const numValue = Number(value)

      this.rentError = ''
      // 周付月付租金上限校验
      if (this.rentCategory === this.CATEGORY_CODE_MAP.ZU_CHE) {
        this.checkZucheAmount(numValue)
      }

      this.formData.amount = value
    },
    checkZucheAmount(numValue) {
      if (this.formData.payMode === PAYMODE_CODE_MAP.WEEK) {
        if (numValue > 2100) {
          this.rentError = '周付租金上限为 2100 元，超出限制请重新设置！'
        }
      } else if (this.formData.payMode === PAYMODE_CODE_MAP.FULL_MOON
        || this.formData.payMode === PAYMODE_CODE_MAP.NATURAL_MONTH) {
        if (this.formData.amountType === AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD) {
          if (numValue > 9000) {
            this.rentError = '月付租金上限为 9000 元，超出限制请重新设置!'
          }
        } else if (this.formData.amountType === AMOUNTTYPE_CODE_MAP.DAILY_RENT) {
          if (numValue > 300) {
            this.rentError = '日付租金上限为 300 元，超出限制请重新设置！'
          }
        }
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    init(tableData) {
      this.$refs.form.clearValidate()
      // 处理数据结构转换
      if (
        this.configData.formData.payMode === PAYMODE_CODE_MAP.STAGES &&
        this.configData.formData.fundType === FEE_CODE_MAP.YA_JIN
      ) {
        // eslint-disable-next-line vue/no-mutating-props
        if (
          this.configData.formData?.items &&
          this.configData.formData?.items?.length > 0
        ) {
          // eslint-disable-next-line vue/no-mutating-props
          this.configData.formData.depositInstallmentList =
            this.configData.formData.items?.map((v, index) => {
              return {
                numberOfPeriods: index + 1,
                presentAmount: v.planAmount || '',
              }
            })
          // eslint-disable-next-line vue/no-mutating-props
          this.formData.amount = this.configData.formData.items?.reduce(
            (sum, item) => {
              return Number(plus(sum, item.planAmount || 0))
            },
            0,
          )
          // eslint-disable-next-line vue/no-mutating-props
          this.configData.formData.amount =
            this.configData.formData.items?.reduce((sum, item) => {
              return Number(plus(sum, item.planAmount || 0))
            }, 0)
        } else if (tableData?.length > 0) {
          // eslint-disable-next-line vue/no-mutating-props
          this.configData.formData.depositInstallmentList = tableData?.map(
            (v, index) => {
              return {
                numberOfPeriods: index + 1,
                presentAmount: v.planAmount || '',
              }
            },
          )

          // eslint-disable-next-line vue/no-mutating-props
          this.formData.amount = tableData?.reduce((sum, item) => {
            return Number(plus(sum, item.planAmount || 0))
          }, 0)
          // eslint-disable-next-line vue/no-mutating-props
          this.configData.formData.amount = tableData?.reduce((sum, item) => {
            return Number(plus(sum, item.planAmount || 0))
          }, 0)
        }
      }

      const formData = Object.assign(this.formData, this.configData.formData)
      this.formData = Object.assign(this.configData.formData, formData)

      // 续约时如果押金选择平移，默认值为无需缴纳费用，且不可编辑；如果选择不平移，则允许用户正常编辑
      if (this.formData.fundType === FEE_CODE_MAP.YA_JIN && this.configData?.formData.isTranDeposit) {
        this.formData.advancePayment = ADVANCE_PAYMENT_CODE.NO_PAYMENT
      } else if (this.configData.formData.advancePayment !== '' && this.configData.formData.advancePayment !== undefined) {
        this.formData.advancePayment = this.configData.formData.advancePayment
      } else {
        this.advancePaymentInit()
      }

      this.depositInstallmentListCopy = cloneDeep(
        this.configData.formData?.depositInstallmentList || [
          {
            numberOfPeriods: 1,
            presentAmount: this.configData.formData.amount || '',
          },
        ],
      )

      this.formData.dynamicList = cloneDeep(this.formData.dynamicList)
      if (Array.isArray(this.formData.dynamicList) && this.formData.dynamicList.length > 0) {
        // 动态租金规则进行处理，每条的第二个输入框设置为disabled(不包含最后一条和倒数第二条)
        this.formData.dynamicList.forEach((item, index, arr) => {
          if (index !== arr.length - 1 && index !== arr.length - 2) {
            item.maxDisabled = true
          }
        })
      }
    },
    amountAccuracyChange() {
      this.formData.amount = ''
      this.formData.rentPerPeriod = ''
      this.formData.rentDay = ''
      this.rentError = ''
    },
    // 收款方式改变
    payModeChange() {
      this.rentError = ''
      this.$refs.form.clearValidate()
      this.formData.amountAccuracy = 2
      this.formData.amount = ''
      this.formData.rentPerPeriod = ''
      this.formData.rentDay = ''
      this.depositInstallmentListCopy = [
        {
          numberOfPeriods: 1,
          presentAmount: '',
        },
      ]
      this.advancePaymentInit()
      this.payModeInit()
    },
    // 修改验证所有期数金额的方法
    async validateAllPeriods() {
      if (
        this.formData.fundType === FEE_CODE_MAP.YA_JIN &&
        this.formData.payMode === 11
      ) {
        try {
          // 只验证未填写金额的行
          const emptyRows = this.depositInstallmentListCopy
            .map((item, index) => ({ item, index }))
            .filter(({ item }) => !item.presentAmount && item.presentAmount !== 0)

          // 清除所有验证错误
          this.$nextTick(() => {
            this.depositInstallmentListCopy.forEach((_, index) => {
              this.$refs.form.clearValidate(`depositInstallmentListCopy[${index}].presentAmount`)
            })
          })

          if (emptyRows.length > 0) {
            // 只验证空行，一个一个验证，不使用展开运算符
            this.$message.warning('请填写所有期数的金额')
            for (const { index } of emptyRows) {
              await this.$refs.form.validateField(`depositInstallmentListCopy[${index}].presentAmount`)
            }
            return false
          }

          return true
        } catch (error) {
          return false
        }
      }
      return true
    },
    // eslint-disable-next-line vue/no-unused-properties
    async returnDepositInstallmentList() {
      const isValid = await this.validateAllPeriods()
      if (!isValid) {
        this.$message.warning('请填写完整的分期金额')
        return [] // 返回空数组而不是 false
      }
      // 当为押金分期时，需要重新计算金额 金额为每一期的综合
      if (
        this?.configData?.fundType === FEE_CODE_MAP.YA_JIN &&
        this?.formData?.payMode === PAYMODE_CODE_MAP.STAGES
      ) {
        this.formData.amount = this.depositInstallmentListCopy.reduce(
          (sum, item) => {
            return Number(plus(sum, Number(item.presentAmount || 0)))
          },
          0,
        )
      }

      return this.depositInstallmentListCopy || [] // 确保返回数组
    },
    /**
     * 不同收款方式对应不同的发车前收款 缴款日等设置的限制
     */
    payModeInit() {
      if (this.formData.payMode === PAYMODE_CODE_MAP.DAY) {
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
      } else if (this.formData.payMode === PAYMODE_CODE_MAP.DISPOSABLE) {
        // 发车前收款：收款方式为“一次性”：默认为“收取全部”，纯文本展示，不可编辑。收取全部 == 发车前需要收齐。
        // 缴款日： 一次性：日期控件 可以选择某个日期。不限制可选择日期的起止。
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
      } else if (this.formData.payMode === PAYMODE_CODE_MAP.WEEK) {
        this.formData.amountType = AMOUNTTYPE_CODE_MAP.AMOUNT_PER_PERIOD
      }
      const { fundType, payMode } = this.formData
      if (
        (fundType === FEE_CODE_MAP.ZU_JIN ||
          fundType === FEE_CODE_MAP.OTHERS) &&
        [
          PAYMODE_CODE_MAP.WEEK,
          PAYMODE_CODE_MAP.FULL_MOON,
          PAYMODE_CODE_MAP.NATURAL_MONTH,
        ].includes(payMode)
      ) {
        this.formData.amountAccuracy = 0
      }
      if (
        this?.configData?.fundType === FEE_CODE_MAP.YA_JIN &&
        this?.formData?.payMode === PAYMODE_CODE_MAP.STAGES
      ) {
        if (!this.formData.amount || this.formData.amount === '0.00') {
          this.formData.amount = ''
        }

        if (!this?.depositInstallmentListCopy?.length) {
          this.depositInstallmentListCopy = [
            {
              numberOfPeriods: 1,
              presentAmount: this.formData.amount || '',
            },
          ]
        }
      }
    },
    /**
    * 提车时需缴纳初始化
    * 对于押金和首付款，提车时需缴纳默认值: 一次性时默认值为全部费用；分期时默认值为首期费用；
    * 其他费项默认值为无需缴纳费用
    */
    advancePaymentInit() {
      if (this.formData.fundType === FEE_CODE_MAP.YA_JIN || this.formData.fundType === FEE_CODE_MAP.SHOU_FU_KUAN) {
        this.formData.advancePayment = this.formData.payMode === 6 ? ADVANCE_PAYMENT_CODE.ALL : ADVANCE_PAYMENT_CODE.FIRST_PERIOD
      } else {
        this.formData.advancePayment = ADVANCE_PAYMENT_CODE.NO_PAYMENT
      }
    },
    // 日租金项是通过给el-form-item设置error来实现，未设置form的rules，外部通过判断error是否有值来判断是否通过校验
    // rentError为空字符串认为通过校验，否则未通过校验
    // eslint-disable-next-line vue/no-unused-properties
    validateDayRent() {
      return this.rentError === ''
    },
    // 收款金额校验
    amountValidate(_, value, callback) {
      if (this.amountRequired && !value) {
        callback(new Error('收款金额不能为空'))
        return
      }
      if (!this.isRenew && this.formData.fundType === FEE_CODE_MAP.ZU_JIN && Number(value) === 0) {
        callback(new Error('租金不能为0'))
        return
      }
      callback()
    },
  },
  created() {
    const { payPlanType } = this.configData.formData
    if (payPlanType === RENT_TYPE.DYNAMICRENT) {
      this.getDynamicRentSpList()
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    'formData.amount': function (n) {
      // 当金额有值时，清除表单验证错误
      if (n && this.$refs.form) {
        // 延迟执行以确保DOM更新完成
        this.$nextTick(() => {
          // 清除amount字段的验证错误
          this.$refs.form.clearValidate('amount')
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.periods {
  ::v-deep .el-form-item__content {
    box-sizing: border-box;
  }
  ::v-deep .el-table {
    border: none;
    border-top: 1px solid #eeeef0;
    border-left: 1px solid #eeeef0;
    border-right: 1px solid #eeeef0;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-top: 8px;
    max-height: 2000px !important;

    /* 添加以下样式 */
    &__body-wrapper {
      height: auto !important;
      max-height: none !important;
    }

    .el-table__body {
      height: auto !important;
    }
  }
  ::v-deep thead {
    > tr {
      > th:nth-child(1) {
        padding-right: 0;
        div.cell {
          position: relative;
          border-right: 1px solid #eeeef0;
        }
      }
      > th:nth-child(3) {
        border-left: 1px solid #eeeef0 !important;
      }
    }
  }
  ::v-deep tbody {
    > tr {
      > td:nth-child(3) {
        border-left: 1px solid #eeeef0 !important;
      }
    }
    .cell {
      margin-top: 9px;
      height: 54px;
      line-height: 34px;
      overflow: hidden;
    }
  }
  ::v-deep .el-table__cell {
    padding: 10px 16px 0px 16px;
  }
  ::v-deep .cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
    font-size: 14px;
  }
  .add-periods {
    padding: 12px 16px;
    border: 1px solid #eeeef0;
    border-top: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}
::v-deep .el-form-item {
  display: block;
}
::v-deep .el-form-item__label {
  float: none;
}
::v-deep .el-form-item__content {
  margin-left: 0px !important;
  flex: 1;
}
::v-deep .el-input-group--append {
  width: 200px;
}
::v-deep .el-select {
  width: 65.5%;
}
::v-deep .el-input {
  width: 100%;
}
::v-deep .el-input__inner {
  width: 100%;
}
.rentRules-orderNum,
.rentRules-money {
  width: 130px;
  margin: 0 5px;
  ::v-deep .el-input__inner {
    ime-mode: disabled;
  }
}
.rentRules ::v-deep .el-form-item--small .el-form-item__error {
  padding-left: 6px !important;
  margin-bottom: 0 !important;
}
::v-deep .el-form-item--small .el-form-item__error {
  margin-bottom: 0 !important;
}
.amountType_box ::v-deep .el-form-item {
  margin-bottom: 0;
}
.amountType_box_item {
  display: flex;
  align-items: center;
  > span {
    display: inline-block;
  }
  > span:nth-child(1) {
    width:35px;
  }
  > span:last-of-type {
    margin-left: 5px;
  }
  ::v-deep .el-input {
    flex: 1;
  }
}
::v-deep .el-select{
  width: 100%;
}
.amountType_box,
.input-container {
  ::v-deep .el-input-group__append {
    width: 40px !important;
  }
  .amountType {
    width: 70%;
    margin-bottom: 6px;
    ::v-deep .el-form-item {
      margin-bottom: 0;
    }
  }
  .input {
    width: 100%;
  }
  .cycleRent {
    width: 45.5%;
  }
  .proportion {
    width: 47.5%;
  }
  ::v-deep .el-input__inner {
    width: 100%;
  }
}
.payDay_box {
  display: flex;
}
.amount {
  display: flex;
  height: 32px;
  line-height: 32px;
  ::v-deep .el-form-item {
    width: 100%;
    .el-form-item__content {
      display: flex;
      .amountDesc {
        margin-right: 5px;
      }
      .amountDesc1 {
        min-width: 50px;
      }
      .amountDesc2 {
        min-width: 80px;
      }
      .el-input-group__append {
        width: 40px !important;
      }
    }
  }
  ::v-deep .el-form-item__error {
    padding-top: 0 !important;
    margin: 0 !important;
    margin-left: 0px !important;
  }
  .amount_tips {
    white-space: nowrap;
  }
}
.ml8 {
  margin-left: 8px;
}
.dynamicItem {
  display: flex;
  align-items: flex-start;
  > .delRentRules {
    line-height: 32px;
  }
}
.period-table {
  width: 100%;

  .period-footer {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .amount-info {
      span {
        margin-right: 16px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

::v-deep .el-table {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-input {
    width: 100%;
  }
}


::v-deep .el-form-item__label {
  float: none;
  display: block; // 修改为 block
  text-align: left; // 确保文字左对齐
  line-height: 32px; // 调整行高
}

::v-deep .el-form-item__content {
  margin-left: 0 !important;
  display: block; // 修改为 block
}

::v-deep .no-error-margin.el-form-item {
  margin-bottom: 0;
}

::v-deep .no-error-margin .el-form-item__error {
  // position: relative;
}
::v-deep .el-alert {
  line-height: 12px;
}
.a-hover-link {
    cursor: auto;
}
</style>
